import { configureStore } from '@reduxjs/toolkit';
import profileReducer from './slices/profileslice';
import globalLoaderSlice from './slices/globalLoader';
import userTypeSlice from './slices/userType';
import GlobalDetailsSlice from './slices/globalDetails';
import authReducer from './slices/authSlice';

const store = configureStore({
    reducer: {
        profile: profileReducer,
        user: userTypeSlice,
        globalLoader: globalLoaderSlice,
        globalData: GlobalDetailsSlice,
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
});

export default store;
